import type {ShouldRenderVarsFnParams} from '@wix/wixstores-client-storefront-common';

export const getResponsiveLayoutShouldRenderVars = ({booleans, isMobile}: ShouldRenderVarsFnParams) => {
  return {
    shouldRenderResponsiveLayoutNavigation: booleans.productPage_navigation || isMobile,
  };
};
